import { Loader2 } from "lucide-react";

import { cx } from "./controlStyles";

// Spinning loader. With `label` it is announced as a status ("Loading
// routines"); without one it is decorative (put the words next to it).
export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <Loader2
      className={cx("h-4 w-4 animate-spin", className)}
      {...(label ? { role: "status", "aria-label": label } : { "aria-hidden": true })}
    />
  );
}
